<template>
  <div class="footer">
    <img class="bottom-img" src="../assets/images/bottom/bg_foot.jpg" alt="" v-if="$route.meta.showImg">
    <div class="f-main">
      <div class="f-top">
        <div class="f-t-left">
          <dl>
            <dt>关于佰讯</dt>
            <dd @click.stop="goTo('/aboutUs')">企业介绍</dd>
            <dd @click.stop="goTo('/aboutUs/companyHonor')">荣誉资质</dd>
            <dd @click.stop="goTo('/aboutUs/news')">新闻中心</dd>
          </dl>
          <dl>
            <dt>合作相关</dt>
            <dd @click.stop="goTo('/joinUs')">加入合作伙伴</dd>
          </dl>
          <dl>
            <dt>帮助中心</dt>
            <dd @click.stop="goTo('/helpCenter')">帮助中心</dd>
            <dd @click.stop="goTo(`/privacyAgreement`)">隐私协议</dd>
            <dd @click.stop="goTo(`/service`)">服务条款</dd>
          </dl>
          <dl>
            <dt>友情链接</dt>
            <dd><a href="http://www.centrin.com.cn/" target="_blank">中金数据系统</a></dd>
            <!-- <dd>友情链接2</dd> -->
          </dl>
          <!-- <dl>
            <dt>模拟演练</dt>
            <dd>模拟演练1</dd>
            <dd>模拟演练2</dd>
            <dd>模拟演练3</dd>
          </dl> -->
        </div>
        <div class="f-t-right">
          <div class="qr-code">
            <img src="../assets/images/QR_code_1.jpg" alt />
            <div>
              <p>扫码关注 <span>武汉佰讯</span> 微信公众号</p>
              <p>客服电话：18571551951</p>
              <p>QQ客服：2224219189</p>
              <p>邮 箱：support@baixuntech.com</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="f-bottom">
      <p>©2018 武汉佰讯科技有限公司.All Rights Reserved</p>
      <p>增值电信业务经营许可证号: 鄂B2-20190165</p>
      <p class="beian">
        <a href="http://www.beian.miit.gov.cn" target="_blank">鄂ICP备20000871号-1</a>
        <a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=42018502004475">
          <img src="../assets/images/gaba.png" />
          <p
            style="margin: 0px 0px 0px 5px;"
          >鄂公网安备 42018502004475号</p>
        </a>
      </p>
    </div>
  </div>
</template>

<script>
import bus from "@/assets/js/bus";
export default {
  name: "officialFoot",
  data() {
    return {};
  },
  methods: {
    goTo(item) {
      this.$router.push(item);
    }
  }
};
</script>

<style lang="scss" scoped>
.footer {
  width: 100%;
  .bottom-img{
    width: 100%;
    height: auto;
  }
}
.f-main {
  /*width: 63.5%;*/
  width: 1280px;
  margin: 0 auto;
}
.f-top {
  height: 210px;
  width: 100%;
  display: flex;
  justify-content: space-between;
  padding-top: 40px;
}
.f-t-left {
  display: flex;
  justify-content: space-between;
  font-size: 14px;
  dl{
    margin-right: 90px;
  }
  dt{
    color: #1D1D1D;
    font-weight: bold;
    margin-bottom: 12px;
    padding-left: 12px;
  }
  dd{
    margin: 10px 0;
    color: #5C5C5C;
    a{
      color: #5C5C5C;
      &:hover{
        color: #3EBBFF;
      }
    }
    cursor: pointer;
    &::before{
      content: '◆';
      margin-right: 6px;
    }
    &:hover{
      color: #3EBBFF;
    }
  }
}
.f-t-right {
  .qr-code {
    display: flex;
    align-items: center;
    font-size: 12px;
    color: #5C5C5C;
    p{
      line-height: 20px;
    }
    span {
      line-height: 30px;
      color: #262626;
    }
    img {
      width: 96px;
      height: auto;
      margin-right: 20px;
    }
  }
}
.f-bottom {
  line-height: 32px;
  font-size: 12px;
  color: #fff;
  background: #313131;
  display: flex;
  justify-content: center;
  align-items: center;
  a{
    display: flex;
    align-items: center;
    margin: 0 5px;
    color: #fff;
    &:hover {
      color: #409EFF;
    }
  }
  .beian{
    display: flex;
  }
}
</style>
